"use strict";
// More information here: https://blog.hackages.io/conditionally-wrap-an-element-in-react-a8b9a47fab2
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const ConditionalWrapper = ({ condition, wrapper, children }) => {
    if (!children) {
        return null;
    }
    return condition ? wrapper(children) : children;
};
exports.default = (0, react_1.memo)(ConditionalWrapper);
//# sourceMappingURL=ConditionalWrapper.js.map